import { render, staticRenderFns } from "./NoticeTemplate.vue?vue&type=template&id=355dc3a0&"
import script from "./NoticeTemplate.vue?vue&type=script&lang=js&"
export * from "./NoticeTemplate.vue?vue&type=script&lang=js&"
import style0 from "./NoticeTemplate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports